var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { id: "mobile-nav" } }, [
    _c("div", { staticClass: "mobile-menu" }, [
      _c(
        "div",
        {
          staticClass: "mobile-menu__primary",
          style: { height: _vm.primaryMenuHeight + "px" }
        },
        [
          _c("div", { staticClass: "mobile-menu__primary__inner" }, [
            _vm.menuData
              ? _c(
                  "div",
                  {
                    ref: "menuDepth0",
                    staticClass:
                      "mobile-menu__panel mobile-menu__panel--depth-0",
                    class: { current: _vm.depth == 0, previous: _vm.depth > 0 }
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "mobile-menu-links" },
                      _vm._l(_vm.menuData, function(post) {
                        return _c("li", { key: post.ID, class: post.classes }, [
                          _c("a", {
                            class: {
                              "has-children":
                                post.children && post.children.length > 0,
                              selected: post.object_id == _vm.currentId
                            },
                            attrs: { href: post.url },
                            domProps: { innerHTML: _vm._s(post.title) },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.didSelectPost(post)
                              }
                            }
                          })
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.depth === 0
                      ? _c(
                          "div",
                          { staticClass: "mobile-menu__footer" },
                          [
                            _vm._t("search"),
                            _vm._v(" "),
                            _vm._t("social"),
                            _vm._v(" "),
                            _vm._t("subscribe")
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menuForDepth1
              ? _c(
                  "div",
                  {
                    ref: "menuDepth1",
                    staticClass:
                      "mobile-menu__panel mobile-menu__panel--depth-1",
                    class: {
                      current: _vm.depth == 1,
                      previous: _vm.depth > 1,
                      next: _vm.depth < 1
                    }
                  },
                  [
                    _vm.selectedMenu0
                      ? _c("div", [
                          _c("a", {
                            staticClass: "back",
                            attrs: { href: _vm.selectedMenu0.url },
                            domProps: { innerHTML: _vm._s("back") },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.didSelectBack()
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedMenu0
                      ? _c(
                          "ul",
                          { staticClass: "mobile-menu-links" },
                          [
                            _c("li", { key: _vm.selectedMenu0.ID }, [
                              _c("a", {
                                attrs: { href: _vm.selectedMenu0.url },
                                domProps: {
                                  innerHTML: _vm._s(_vm.selectedMenu0.title)
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.didSelectPost(
                                      _vm.selectedMenu0,
                                      true
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.menuForDepth1, function(post) {
                              return _c(
                                "li",
                                { key: post.ID, class: post.classes },
                                [
                                  _c("a", {
                                    class: {
                                      "has-children":
                                        post.children &&
                                        post.children.length > 0
                                    },
                                    attrs: { href: post.url },
                                    domProps: { innerHTML: _vm._s(post.title) },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.didSelectPost(post)
                                      }
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menuForDepth2
              ? _c(
                  "div",
                  {
                    ref: "menuDepth2",
                    staticClass:
                      "mobile-menu__panel mobile-menu__panel--depth-2",
                    class: {
                      current: _vm.depth == 2,
                      previous: _vm.depth > 2,
                      next: _vm.depth < 2
                    }
                  },
                  [
                    _vm.selectedMenu1
                      ? _c("div", [
                          _c("a", {
                            staticClass: "back",
                            attrs: { href: _vm.selectedMenu1.url },
                            domProps: { innerHTML: _vm._s("back") },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.didSelectBack()
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedMenu1
                      ? _c(
                          "ul",
                          { staticClass: "mobile-menu-links" },
                          [
                            _c("li", { key: _vm.selectedMenu1.ID }, [
                              _c("a", {
                                attrs: { href: _vm.selectedMenu1.url },
                                domProps: {
                                  innerHTML: _vm._s(_vm.selectedMenu1.title)
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.didSelectPost(
                                      _vm.selectedMenu1,
                                      true
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.menuForDepth2, function(post) {
                              return _c(
                                "li",
                                { key: post.ID, class: post.classes },
                                [
                                  _c("a", {
                                    class: {
                                      "has-children":
                                        post.children &&
                                        post.children.length > 0
                                    },
                                    attrs: { href: post.url },
                                    domProps: { innerHTML: _vm._s(post.title) },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.didSelectPost(post)
                                      }
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menuForDepth3
              ? _c(
                  "div",
                  {
                    ref: "menuDepth3",
                    staticClass:
                      "mobile-menu__panel mobile-menu__panel--depth-3",
                    class: { current: _vm.depth == 3, next: _vm.depth < 3 }
                  },
                  [
                    _vm.selectedMenu2
                      ? _c("div", [
                          _c("a", {
                            staticClass: "back",
                            attrs: { href: _vm.selectedMenu2.url },
                            domProps: {
                              innerHTML: _vm._s(_vm.selectedMenu2.title)
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.didSelectBack()
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "mobile-menu-links" },
                      _vm._l(_vm.menuForDepth3, function(post) {
                        return _c("li", { key: post.ID, class: post.classes }, [
                          _c("a", {
                            class: {
                              "has-children":
                                post.children && post.children.length > 0
                            },
                            attrs: { href: post.url },
                            domProps: { innerHTML: _vm._s(post.title) },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.didSelectPost(post)
                              }
                            }
                          })
                        ])
                      }),
                      0
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/MobileMenu.vue?vue&type=template&id=1e51ca55&
// module id = 122
// module chunks = 0